import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import otterImg from '../assets/images/otter.png';
import './WelcomeModal.css';

const WelcomeModal = ({ onClose }) => {
  const { t } = useLanguage();

  return (
    <div className="welcome-modal" onClick={onClose}>
      <div className="welcome-container" onClick={(e) => e.stopPropagation()}>
        <div className="welcome-header">
          <img src={otterImg} alt="Wetland Guardian" className="welcome-logo" />
          <h2>{t('welcomeTitle')}</h2>
          <button className="welcome-close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="welcome-body">
          <p>
            {t('welcomeText1')}
            <strong>Wetland Guardian</strong>
            {t('welcomeText2')}
            <strong>Wetland Guardian</strong>
            {t('welcomeText3')}
          </p>
        </div>

        <div className="welcome-footer">
          <button className="welcome-ok-button" onClick={onClose}>
            {t('welcomeOk')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
